export default "__VITE_ASSET__BHEI_3vZ__"